// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"style_buttonsContainer__UuH+J"};